import React from "react"

/**
 * Иконка «?» рядом с подписью поля: пояснение показывается нативным title при наведении,
 * чтобы длинные подсказки не растягивали форму строками серого текста под полем.
 */
function HintIcon({ text, className = '' }) {
	if (!text) return null

	return (
		<i
			className={`uil-question-circle ms-1 ${className}`}
			title={text}
			style={{ fontSize: '14px', color: 'var(--dark-text-muted, #98a6ad)', cursor: 'help', verticalAlign: 'middle' }}
		></i>
	)
}

export default HintIcon
